import { Injectable } from '@angular/core';
import { UserProfileActions } from '@gestor-web/@core/store/actions';
import { CookieConsentData } from '@gestor-web/@core/types';
import { Store } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject } from 'rxjs';

const COOKIE_NAME = 'GESTORWEB_COOKIE_CONSENT';

const COOKIE_EMPTY = Object.freeze({
  accept_all: false,
  accept_necessary: false,
  consent_time: 0,
});

const COOKIE_VALID_DAYS = 365;

@Injectable({
  providedIn: 'root',
})
export class CookieConsentService {
  private cookieData = new BehaviorSubject<CookieConsentData>(null);

  constructor(
    private cookieService: CookieService,
    private store: Store,
  ) {}

  checkCookies() {
    let cookie: CookieConsentData = null;

    const exists = this.cookieService.check(COOKIE_NAME);
    if (exists) {
      const value = this.cookieService.get(COOKIE_NAME);
      if (value) {
        try {
          cookie = JSON.parse(value);
        } catch (e) {
          console.error('Invalid cookie format: ', e);
        }
      }
    }

    // console.log('cookie:', cookie);
    cookie = {
      accept_all: cookie?.accept_all ?? false,
      accept_necessary: cookie?.accept_necessary ?? false,
      consent_time: cookie?.consent_time ?? 0,
    };
    // console.log('cookie:', cookie);

    if (!cookie.consent_time) {
      cookie = { ...COOKIE_EMPTY };
    }

    let showBanner = true;

    // User already choose, do no show
    if (cookie.accept_all || cookie.accept_necessary) {
      showBanner = false;
    }

    this.store.dispatch(
      UserProfileActions.cookiesConsentUpdate({
        showBanner,
        acceptAll: cookie.accept_all,
      }),
    );
  }

  consentCookies(all: boolean) {
    const consent_time = new Date().getTime();

    const cookie: CookieConsentData = {
      accept_all: all,
      accept_necessary: !all,
      consent_time,
    };

    // console.log('consent:', cookie);

    const cookieString = JSON.stringify(cookie);

    this.cookieService.delete(COOKIE_NAME, '/');
    this.cookieService.set(COOKIE_NAME, cookieString, COOKIE_VALID_DAYS, '/');

    this.store.dispatch(
      UserProfileActions.cookiesConsentUpdate({
        showBanner: false,
        acceptAll: all,
      }),
    );
  }

  clearCookieConsent() {
    this.cookieService.delete(COOKIE_NAME, '/');
    this.store.dispatch(
      UserProfileActions.cookiesConsentUpdate({
        showBanner: true,
        acceptAll: false,
      }),
    );
  }
}
